import './Certifications.css';

const certs = [
  {
    issuer: 'Google Cloud',
    name: 'Data, ML, and AI in Google Cloud',
    code: 'Google Cloud Skills Boost',
    date: 'Aug 2022',
    color: '#4285F4',
  },
  {
    issuer: 'NVIDIA',
    name: 'Fundamentals of Deep Learning',
    code: 'Deep Learning Institute',
    date: 'Jun 2022',
    color: '#76B900',
  },
  {
    issuer: 'IBM',
    name: 'Data Science Methodology',
    code: 'IBM Certificate',
    date: 'Oct 2021',
    color: '#1F70C1',
  },
  {
    issuer: 'IBM',
    name: 'Data Science Tools',
    code: 'IBM Certificate',
    date: 'Oct 2021',
    color: '#1F70C1',
  },
];

function Certifications() {
  return (
    <div className="certifications">
      <h2>Certifications</h2>
      <div className="cert-grid">
        {certs.map((c, i) => (
          <div key={`${c.code}-${i}`} className="cert-card" style={{ borderTopColor: c.color }}>
            <span className="cert-issuer" style={{ color: c.color }}>{c.issuer}</span>
            <h3>{c.name}</h3>
            <span className="cert-code">{c.code}</span>
            <span className="cert-date">{c.date}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Certifications;
